import { isPlatform } from '@ionic/react';
import IApiResponse from "../interfaces/IApiResponse";
import IDismissibleMessage from "../interfaces/IDismissibleMessage";
import DismissibleMessageServiceHybrid from './hybrid/DismissibleMessageServiceHybrid';
import DismissibleMessageServiceWeb from "./web/DismissibleMessageServiceWeb";
export interface IDismissibleMessageService {
    logDismissibleMessage: (dismissibleMessage: IDismissibleMessage) => Promise<IApiResponse<IDismissibleMessage>>,
    getDismissibleMessages: (category: string) =>  Promise<IApiResponse<IDismissibleMessage[]>>,
    getAllDismissibleMessages: () =>  Promise<IApiResponse<IDismissibleMessage[]>>,
    getDismissibleMessage: (messageId: string) =>  Promise<IApiResponse<IDismissibleMessage>>,
    updateDismissibleMessage: (dismissibleMessage: IDismissibleMessage) => Promise<IApiResponse<IDismissibleMessage>>,
}

const DismissibleMessageService: IDismissibleMessageService = {
    
    logDismissibleMessage: (dismissibleMessage) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - DismissibleMessageService')
            return DismissibleMessageServiceHybrid.logDismissibleMessage(dismissibleMessage);
        } else {
            console.log('WEB - DismissibleMessageService')
            return DismissibleMessageServiceWeb.logDismissibleMessage(dismissibleMessage);
        }    
    },
    getDismissibleMessages: (category: string) =>  {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - DismissibleMessageService')
            return DismissibleMessageServiceHybrid.getDismissibleMessages(category);
        } else {
            console.log('WEB - DismissibleMessageService')
            return DismissibleMessageServiceWeb.getDismissibleMessages(category);
        }  
    },
    getAllDismissibleMessages: () =>  {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - DismissibleMessageService')
            return DismissibleMessageServiceHybrid.getAllDismissibleMessages();
        } else {
            console.log('WEB - DismissibleMessageService')
            return DismissibleMessageServiceWeb.getAllDismissibleMessages();
        } 
    },
    getDismissibleMessage: (messageId: string) =>  {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - DismissibleMessageService')
            return DismissibleMessageServiceHybrid.getDismissibleMessage(messageId);
        } else {
            console.log('WEB - DismissibleMessageService')
            return DismissibleMessageServiceWeb.getDismissibleMessage(messageId);
        } 
    },
    updateDismissibleMessage: (dismissibleMessage) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - DismissibleMessageService')
            return DismissibleMessageServiceHybrid.updateDismissibleMessage(dismissibleMessage);
        } else {
            console.log('WEB - DismissibleMessageService')
            return DismissibleMessageServiceWeb.updateDismissibleMessage(dismissibleMessage);
        } 
    },
}

export default DismissibleMessageService;